import type { TvChannel } from './tv'

export const ScheduleType = {
  HOURLY: 'HOURLY',
  EPG: 'EPG',
} as const
export type ScheduleType = (typeof ScheduleType)[keyof typeof ScheduleType]

export interface Catchup {
  id: number
  sortOrder: number
  days: number
  scheduleType: ScheduleType
  channel: TvChannel
}

export interface CatchupProgram {
  id: number
  name: string
  startMs: number
  endMs: number
  dateStartMs: number
}

export type CatchupProgramsWithDates = { [timestamp: number]: CatchupProgram[] }
export type CatchupsDateList = number[]

export interface CatchupProgramsFormatedToObjectWithDatelist {
  dateList: CatchupsDateList
  programs: CatchupProgramsWithDates
}
